var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcListHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icListHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final-Home-with-submenu",
    transform: "translate(-1249.000000, -198.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1079.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(16.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lists",
    transform: "translate(115.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(28.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lists",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,29 L28,29 L28,0 L0,0 Z M6.4,24.8789474 C5.3,24.8789474 4.45,23.9631579 4.45,22.8947368 C4.45,21.8263158 5.35,20.9105263 6.4,20.9105263 C7.45,20.9105263 8.35,21.8263158 8.35,22.8947368 C8.35,23.9631579 7.45,24.8789474 6.4,24.8789474 L6.4,24.8789474 Z M6.4,17.145614 C5.3,17.145614 4.45,16.2298246 4.45,15.1614035 C4.45,14.0929825 5.35,13.177193 6.4,13.177193 C7.45,13.177193 8.35,14.0929825 8.35,15.1614035 C8.35,16.2298246 7.45,17.145614 6.4,17.145614 L6.4,17.145614 Z M6.4,9.25964912 C5.3,9.25964912 4.45,8.34385965 4.45,7.2754386 C4.45,6.20701754 5.35,5.29122807 6.4,5.29122807 C7.45,5.29122807 8.35,6.20701754 8.35,7.2754386 C8.35,8.34385965 7.45,9.25964912 6.4,9.25964912 Z M23.6,23.0982456 C23.6,23.5561404 23.25,23.9122807 22.8,23.9122807 L22.8,23.9122807 L10.6,23.9122807 C10.15,23.9122807 9.8,23.5561404 9.8,23.0982456 L9.8,23.0982456 L9.8,22.6912281 C9.8,22.2333333 10.15,21.877193 10.6,21.877193 L10.6,21.877193 L22.8,21.877193 C23.25,21.877193 23.6,22.2333333 23.6,22.6912281 L23.6,22.6912281 L23.6,23.0982456 L23.6,23.0982456 Z M23.6,15.3140351 C23.6,15.7719298 23.25,16.1280702 22.8,16.1280702 L22.8,16.1280702 L10.6,16.1280702 C10.15,16.1280702 9.8,15.7719298 9.8,15.3140351 L9.8,15.3140351 L9.8,14.9070175 C9.8,14.4491228 10.15,14.0929825 10.6,14.0929825 L10.6,14.0929825 L22.8,14.0929825 C23.25,14.0929825 23.6,14.4491228 23.6,14.9070175 L23.6,14.9070175 L23.6,15.3140351 L23.6,15.3140351 Z M23.6,7.42807018 C23.6,7.88596491 23.25,8.24210526 22.8,8.24210526 L22.8,8.24210526 L10.6,8.24210526 C10.15,8.24210526 9.8,7.88596491 9.8,7.42807018 L9.8,7.42807018 L9.8,7.02105263 C9.8,6.56315789 10.15,6.20701754 10.6,6.20701754 L10.6,6.20701754 L22.8,6.20701754 C23.25,6.20701754 23.6,6.56315789 23.6,7.02105263 L23.6,7.02105263 L23.6,7.42807018 L23.6,7.42807018 Z",
    id: "icListHeader"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListHeader);
export default __webpack_public_path__ + "static/media/icListHeader.af438f885e2f8c0fdf4c2116c2256374.svg";
export { ForwardRef as ReactComponent };